var _defs, _path, _path2, _g, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _g3, _path9, _path10, _path11, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _path12, _path13, _path14, _path15, _g12, _g13, _path16, _path17, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _path18, _path19, _path20, _path21, _g23, _g24, _g25, _g26, _g27, _g28, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _path29, _g40, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g41, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _g42, _path68, _g43, _g44, _g45, _g46, _g47;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebdevdet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_660",
    "data-name": "Group 660",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84.631,
    height: 64.782,
    viewBox: "0 0 84.631 64.782",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M0-505.029H84.558v-64.782H0Z",
    transform: "translate(0 569.811)",
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M348.045-95.212H337.606v-11.724h10.439Z",
    transform: "translate(-299.223 159.561)",
    fill: "#140577"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M348.045-102.861H337.606v-4.075h10.439Z",
    transform: "translate(-299.223 159.561)",
    fill: "#140577"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(33.811 61.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M-152.656-25.536h-19.582v-1.3a1.978,1.978,0,0,1,1.978-1.978h15.626a1.978,1.978,0,0,1,1.978,1.978Z",
    transform: "translate(172.238 28.812)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(14.63 16.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M-436.834-294.894h-54.125a1.91,1.91,0,0,1-1.91-1.91v-34.007a1.91,1.91,0,0,1,1.91-1.91h54.125a1.91,1.91,0,0,1,1.91,1.91V-296.8a1.91,1.91,0,0,1-1.91,1.91",
    transform: "translate(492.869 332.721)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(16.164 17.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M0-264.976V-298.2a.77.77,0,0,1,.77-.77H54.107a.77.77,0,0,1,.77.77v33.219a.77.77,0,0,1-.77.77H.77a.77.77,0,0,1-.77-.77",
    transform: "translate(0 298.966)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(2.067 10.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M-206.5-133.48h-25.964a.526.526,0,0,1-.525-.525v-16.071a.525.525,0,0,1,.525-.525H-206.5a.525.525,0,0,1,.525.525v16.071a.525.525,0,0,1-.525.525",
    transform: "translate(232.992 150.602)",
    fill: "#9b2dff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(2.44 11.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M0-116.021v-14.468a.414.414,0,0,1,.414-.414H25.855a.414.414,0,0,1,.414.414v14.468a.414.414,0,0,1-.414.414H.414A.414.414,0,0,1,0-116.021",
    transform: "translate(0 130.903)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(27.851 10.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M-5.334-2.667a.342.342,0,0,1-.342.342.342.342,0,0,1-.342-.342.342.342,0,0,1,.342-.342.342.342,0,0,1,.342.342",
    transform: "translate(6.018 3.009)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(26.721 10.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M-5.334-2.667a.342.342,0,0,1-.342.342.342.342,0,0,1-.342-.342.342.342,0,0,1,.342-.342.342.342,0,0,1,.342.342",
    transform: "translate(6.018 3.009)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(25.59 10.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M-5.335-2.667a.342.342,0,0,1-.342.342.342.342,0,0,1-.342-.342.342.342,0,0,1,.342-.342.342.342,0,0,1,.342.342",
    transform: "translate(6.019 3.009)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(3.38 13.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M-21.564-10.782A1.383,1.383,0,0,1-22.947-9.4a1.383,1.383,0,0,1-1.383-1.383,1.383,1.383,0,0,1,1.383-1.383,1.383,1.383,0,0,1,1.383,1.383",
    transform: "translate(24.33 12.165)",
    fill: "#ffcc6d"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M80.275-452.18H59.652v-.653H80.275Z",
    transform: "translate(-52.87 466.132)",
    fill: "#d6d3ea"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M73.687-442.983H59.651v-.653H73.687Z",
    transform: "translate(-52.869 457.981)",
    fill: "#d6d3ea"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M66.951-433.22h-7.3v-.653h7.3Z",
    transform: "translate(-52.87 449.328)",
    fill: "#d6d3ea"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(3.38 17.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M-21.564-10.782A1.383,1.383,0,0,1-22.947-9.4a1.383,1.383,0,0,1-1.383-1.383,1.383,1.383,0,0,1,1.383-1.383,1.383,1.383,0,0,1,1.383,1.383",
    transform: "translate(24.33 12.165)",
    fill: "#3da0b7"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M80.275-413.437H59.652v-.653H80.275Z",
    transform: "translate(-52.87 431.794)",
    fill: "#d6d3ea"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M73.687-404.241H59.651v-.653H73.687Z",
    transform: "translate(-52.869 423.644)",
    fill: "#d6d3ea"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M66.951-394.478h-7.3v-.653h7.3Z",
    transform: "translate(-52.87 414.99)",
    fill: "#d6d3ea"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(3.38 22.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M-21.564-10.782A1.383,1.383,0,0,1-22.947-9.4a1.383,1.383,0,0,1-1.383-1.383,1.383,1.383,0,0,1,1.383-1.383,1.383,1.383,0,0,1,1.383,1.383",
    transform: "translate(24.33 12.165)",
    fill: "#ff5e63"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M80.275-374.695H59.652v-.653H80.275Z",
    transform: "translate(-52.87 397.457)",
    fill: "#d6d3ea"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M73.687-365.5H59.651v-.653H73.687Z",
    transform: "translate(-52.869 389.306)",
    fill: "#d6d3ea"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M66.951-355.736h-7.3v-.653h7.3Z",
    transform: "translate(-52.87 380.653)",
    fill: "#d6d3ea"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(30.005 28.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M-2.789,0V.358h-.358",
    transform: "translate(3.147)",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(1.295 29.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M-218.292,0h-28",
    transform: "translate(246.293)",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "2.967 2.967"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(0.583 28.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M-2.789-2.789h-.358v-.358",
    transform: "translate(3.147 3.147)",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(0.583 9.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M0-143.644V-162.07",
    transform: "translate(0 162.07)",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.058 3.058"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(0.583 9.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M0-2.789v-.358H.358",
    transform: "translate(0 3.147)",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(1.65 9.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M0,0H28",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "2.967 2.967"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(30.005 9.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M0,0H.358V.358",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    transform: "translate(30.363 10.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M0,0V18.426",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.058 3.058"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M0-493.973H1.166v-1.166H0Z",
    transform: "translate(0 503.628)",
    fill: "#140577"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M0-316.076H1.166v-1.166H0Z",
    transform: "translate(0 345.957)",
    fill: "#140577"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M263.105-493.974h-1.166v-1.166h1.166Z",
    transform: "translate(-232.159 503.629)",
    fill: "#140577"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M263.105-316.076h-1.166v-1.166h1.166Z",
    transform: "translate(-232.159 345.957)",
    fill: "#38356d"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(62.157 44.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M-158.335-112.809h-19.786a.524.524,0,0,1-.524-.524v-13.422a.524.524,0,0,1,.524-.524h19.786a.524.524,0,0,1,.524.524v13.422a.524.524,0,0,1-.524.524",
    transform: "translate(178.645 127.279)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(62.472 45.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M0-98.186v-12.262a.333.333,0,0,1,.333-.333H19.872a.333.333,0,0,1,.333.333v12.262a.333.333,0,0,1-.333.333H.333A.333.333,0,0,1,0-98.186",
    transform: "translate(0 110.781)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(81.951 44.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M-4.508-2.254a.289.289,0,0,1-.289.289.289.289,0,0,1-.289-.289A.289.289,0,0,1-4.8-2.543a.289.289,0,0,1,.289.289",
    transform: "translate(5.086 2.543)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(80.996 44.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M-4.508-2.254a.289.289,0,0,1-.289.289.289.289,0,0,1-.289-.289A.289.289,0,0,1-4.8-2.543a.289.289,0,0,1,.289.289",
    transform: "translate(5.086 2.543)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    transform: "translate(80.041 44.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M-4.508-2.254a.289.289,0,0,1-.289.289.289.289,0,0,1-.289-.289A.289.289,0,0,1-4.8-2.543a.289.289,0,0,1,.289.289",
    transform: "translate(5.086 2.543)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(69.573 48.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M-46.8-23.4a3,3,0,0,1-3,3,3,3,0,0,1-3-3,3,3,0,0,1,3-3,3,3,0,0,1,3,3",
    transform: "translate(52.8 26.4)",
    fill: "#9b2dff"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    transform: "translate(71.551 50.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M-21.662-12.507l-1.389.8-1.389.8v-3.209l1.389.8Z",
    transform: "translate(24.441 14.111)",
    fill: "#fff"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M569.695-68.508h-20.2v-.4h20.2Z",
    transform: "translate(-487.018 125.854)",
    fill: "#d6d3ea"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M554.042-68.508H549.49v-.4h4.552Z",
    transform: "translate(-487.018 125.854)",
    fill: "#f2a51c"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(66.718 56.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M-4.761-2.381a.305.305,0,0,1-.305.305.305.305,0,0,1-.305-.305.305.305,0,0,1,.305-.305.305.305,0,0,1,.305.305",
    transform: "translate(5.372 2.686)",
    fill: "#f2a51c"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(83.748 59.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M-2.789,0V.358h-.358",
    transform: "translate(3.147)",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(61.761 59.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M-165.789,0h-21.267",
    transform: "translate(187.056)",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.066 3.066"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    transform: "translate(61.043 59.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M-2.789-2.789h-.358v-.358",
    transform: "translate(3.147 3.147)",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    transform: "translate(61.043 43.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M0-116.138v-14.9",
    transform: "translate(0 131.035)",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "2.912 2.912"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(61.043 43.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M0-2.789v-.358H.358",
    transform: "translate(0 3.147)",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(62.121 43.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M0,0H21.267",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.066 3.066"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(83.748 43.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M0,0H.358V.358",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(84.106 44.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M0,0V14.9",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "2.912 2.912"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M533.849-192.563h-.9v-.9h.9Z",
    transform: "translate(-472.355 236.253)",
    fill: "#38356d"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M533.849-46.092h-.9v-.9h.9Z",
    transform: "translate(-472.355 106.434)",
    fill: "#38356d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M735.808-192.563h.9v-.9h-.9Z",
    transform: "translate(-652.153 236.253)",
    fill: "#38356d"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M735.808-46.093h.9V-47h-.9Z",
    transform: "translate(-652.153 106.435)",
    fill: "#38356d"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(69.357 13.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M-79.614-60.373h-9.864a.349.349,0,0,1-.349-.349v-7.047a.349.349,0,0,1,.349-.349h4.009a.349.349,0,0,1,.246.1l.652.652a.349.349,0,0,0,.247.1h4.71a.349.349,0,0,1,.349.349v6.191a.349.349,0,0,1-.349.349",
    transform: "translate(89.827 68.117)",
    fill: "#140577"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(70.302 8.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M-65.28-10.318v8.87h-8.374V-11.642h7.05Z",
    transform: "translate(73.654 11.642)",
    fill: "#d6d3ea"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(77.353 8.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M0-10.318v-1.324l1.324,1.324Z",
    transform: "translate(0 11.642)",
    fill: "#ccc9e0"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(70.821 8.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M-65.28-10.318v8.87h-8.374V-11.642h7.05Z",
    transform: "translate(73.654 11.642)",
    fill: "#e8e5ff"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(69.728 14.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M-79.614-52.571h-9.864a.349.349,0,0,1-.349-.349v-6.046a.349.349,0,0,1,.349-.349h4.009a.349.349,0,0,1,.246.1l.652.652a.348.348,0,0,0,.247.1h4.71a.349.349,0,0,1,.349.349v5.19a.349.349,0,0,1-.349.349",
    transform: "translate(89.827 59.314)",
    fill: "#9b2dff"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(77.871 8.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M0-10.318v-1.324l1.324,1.324Z",
    transform: "translate(0 11.642)",
    fill: "#ccc9e0"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M632.412-487.393h-6.341v-.345h6.341Z",
    transform: "translate(-554.892 497.069)",
    fill: "#ccc9e0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M633.881-476.1h-7.616v-.217h7.616Z",
    transform: "translate(-555.064 486.945)",
    fill: "#ccc9e0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M633.881-470.689h-7.616v-.217h7.616Z",
    transform: "translate(-555.064 482.151)",
    fill: "#ccc9e0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M632.526-465.279h-6.26v-.217h6.26Z",
    transform: "translate(-555.065 477.356)",
    fill: "#ccc9e0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M632.526-459.868h-6.26v-.217h6.26Z",
    transform: "translate(-555.065 472.56)",
    fill: "#ccc9e0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M630.5-454.458h-4.232v-.217H630.5Z",
    transform: "translate(-555.064 467.765)",
    fill: "#ccc9e0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M630.5-449.047h-4.232v-.217H630.5Z",
    transform: "translate(-555.064 462.969)",
    fill: "#ccc9e0"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(74.17 36.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M-.174-37.954a5.683,5.683,0,0,0,.528-1.36v-2.9a.605.605,0,0,1,.605-.605h7.63a.605.605,0,0,1,.605.605v3.088a.605.605,0,0,1-.605.605H1.364a2.614,2.614,0,0,1-1.369.8.157.157,0,0,1-.17-.233",
    transform: "translate(0.196 42.823)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    transform: "translate(80.233 37.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M-3.623-.549A.7.7,0,0,1-2.7-.26a.7.7,0,0,1,.923-.289.93.93,0,0,1,.461.9,1.434,1.434,0,0,1-.5.921A3.175,3.175,0,0,1-2.7,1.8a3.175,3.175,0,0,1-.885-.525,1.434,1.434,0,0,1-.5-.921.93.93,0,0,1,.461-.9",
    transform: "translate(4.087 0.62)",
    fill: "#fff"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(75.46 38.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M-6.484,0V1.775h-.5V.388h-.33V0Z",
    transform: "translate(7.316)",
    fill: "#fff"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(76.558 38.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M-2.945-13.54a.733.733,0,0,1-.278-.318,1.137,1.137,0,0,1-.1-.5,1.136,1.136,0,0,1,.1-.5.735.735,0,0,1,.278-.318.761.761,0,0,1,.406-.109.756.756,0,0,1,.4.109.736.736,0,0,1,.278.318,1.139,1.139,0,0,1,.1.5,1.14,1.14,0,0,1-.1.5.735.735,0,0,1-.278.318.755.755,0,0,1-.4.109.76.76,0,0,1-.406-.109m.607-.425a.775.775,0,0,0,.075-.389.776.776,0,0,0-.075-.389.227.227,0,0,0-.2-.123.23.23,0,0,0-.2.123.776.776,0,0,0-.075.389.776.776,0,0,0,.075.389.23.23,0,0,0,.2.123.227.227,0,0,0,.2-.123",
    transform: "translate(3.323 15.277)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(78.295 38.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M-2.945-13.54a.733.733,0,0,1-.278-.318,1.137,1.137,0,0,1-.1-.5,1.136,1.136,0,0,1,.1-.5.735.735,0,0,1,.278-.318.761.761,0,0,1,.406-.109.756.756,0,0,1,.4.109.736.736,0,0,1,.278.318,1.139,1.139,0,0,1,.1.5,1.14,1.14,0,0,1-.1.5.735.735,0,0,1-.278.318.755.755,0,0,1-.4.109.76.76,0,0,1-.406-.109m.607-.425a.775.775,0,0,0,.075-.389.776.776,0,0,0-.075-.389.227.227,0,0,0-.2-.123.23.23,0,0,0-.2.123.775.775,0,0,0-.075.389.774.774,0,0,0,.075.389.23.23,0,0,0,.2.123.227.227,0,0,0,.2-.123",
    transform: "translate(3.323 15.277)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    transform: "translate(18.101 20.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M-389.092-232.19h-48.82A1.091,1.091,0,0,1-439-233.281v-27.6a1.091,1.091,0,0,1,1.091-1.091h48.82A1.091,1.091,0,0,1-388-260.883v27.6a1.091,1.091,0,0,1-1.091,1.091",
    transform: "translate(439.003 261.974)",
    fill: "#9b2dff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(18.805 22.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M0-200.2V-225.22a.657.657,0,0,1,.657-.657h48.28a.657.657,0,0,1,.657.657V-200.2a.657.657,0,0,1-.657.657H.657A.657.657,0,0,1,0-200.2",
    transform: "translate(0 225.877)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(66.779 20.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M-10.071-5.035a.646.646,0,0,1-.646.646.646.646,0,0,1-.646-.646.646.646,0,0,1,.646-.646.646.646,0,0,1,.646.646",
    transform: "translate(11.363 5.681)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(64.645 20.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M-10.07-5.035a.646.646,0,0,1-.646.646.646.646,0,0,1-.646-.646.646.646,0,0,1,.646-.646.646.646,0,0,1,.646.646",
    transform: "translate(11.362 5.681)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(62.511 20.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M-10.07-5.035a.646.646,0,0,1-.646.646.646.646,0,0,1-.646-.646.646.646,0,0,1,.646-.646.646.646,0,0,1,.646.646",
    transform: "translate(11.362 5.681)",
    fill: "#fff"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(38.574 37.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M-2.789,0V.358h-.358",
    transform: "translate(3.147)",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(20.805 37.796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M-132.87,0h-17.044",
    transform: "translate(149.914)",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.059 3.059"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(20.085 37.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M-2.789-2.789h-.358v-.358",
    transform: "translate(3.147 3.147)",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(20.085 25.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M0-91.084v-11.684",
    transform: "translate(0 102.768)",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.114 3.114"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(20.085 24.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M0-2.789v-.358H.358",
    transform: "translate(0 3.147)",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(21.168 24.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M0,0H17.044",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.059 3.059"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(38.574 24.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M0,0H.358V.358",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(38.932 25.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M0,0V11.684",
    fill: "none",
    stroke: "#38356d",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.114 3.114"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M214.892-323.658H196.045v-13.53h18.847Z",
    transform: "translate(-173.756 363.635)",
    fill: "#140577"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(23.47 28.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M-128.208-84.552h-16.446l5.182-9.775,3.894,6.718,2.641-2.788Zm-4.986-9.237A1.609,1.609,0,0,1-134.8-92.18a1.609,1.609,0,0,1-1.609-1.609A1.609,1.609,0,0,1-134.8-95.4,1.609,1.609,0,0,1-133.194-93.789Z",
    transform: "translate(144.654 95.398)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M404.352-353.088H380.875v-1.444h23.477Z",
    transform: "translate(-337.573 379.007)",
    fill: "#d6d3ea"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M387.622-330.425h-6.747v-.722h6.747Z",
    transform: "translate(-337.573 358.281)",
    fill: "#d6d3ea"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M451.051-330.425h-2.738v-.722h2.738Z",
    transform: "translate(-397.344 358.281)",
    fill: "#d6d3ea"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M488.832-330.425h-7.185v-.722h7.185Z",
    transform: "translate(-426.888 358.281)",
    fill: "#d6d3ea"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M554.1-330.425h-4.268v-.722H554.1Z",
    transform: "translate(-487.324 358.281)",
    fill: "#d6d3ea"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M389.768-314.6h-8.893v-.722h8.893Z",
    transform: "translate(-337.573 344.255)",
    fill: "#d6d3ea"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M471.235-314.6h-3.461v-.722h3.461Z",
    transform: "translate(-414.592 344.255)",
    fill: "#d6d3ea"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M508.614-314.6h-3.461v-.722h3.461Z",
    transform: "translate(-447.722 344.255)",
    fill: "#d6d3ea"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M544.69-314.6H540.3v-.722h4.394Z",
    transform: "translate(-478.869 344.255)",
    fill: "#d6d3ea"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M383.35-298.776h-2.475v-.722h2.475Z",
    transform: "translate(-337.573 330.23)",
    fill: "#d6d3ea"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M487.44-298.776h-4.447v-.722h4.447Z",
    transform: "translate(-428.081 330.23)",
    fill: "#d6d3ea"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M415.477-298.776h-7.82v-.722h7.82Z",
    transform: "translate(-361.31 330.23)",
    fill: "#d6d3ea"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M386.483-282.951h-5.608v-.722h5.608Z",
    transform: "translate(-337.573 316.204)",
    fill: "#d6d3ea"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M440.562-282.951h-1.884v-.722h1.884Z",
    transform: "translate(-388.804 316.204)",
    fill: "#d6d3ea"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M466.658-282.951h-3.7v-.722h3.7Z",
    transform: "translate(-410.322 316.204)",
    fill: "#d6d3ea"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M383.02-267.128h-2.146v-.722h2.146Z",
    transform: "translate(-337.572 302.18)",
    fill: "#d6d3ea"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M411.6-267.128h-4.71v-.722h4.71Z",
    transform: "translate(-360.628 302.18)",
    fill: "#d6d3ea"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M197.713-199.283H176.662v-6.262h21.051Z",
    transform: "translate(-156.577 246.958)",
    fill: "#d6d3ea"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M185.576-198.093h-3.995v-3.716h3.995Z",
    transform: "translate(-160.937 243.647)",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M185.576-163.166h-3.995v-1.1h3.995Z",
    transform: "translate(-160.937 210.376)",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M226.358-187.241h3.995v3.716h-3.995Z",
    transform: "translate(-200.623 230.736)",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M226.358-201.809h3.995v1.1h-3.995Z",
    transform: "translate(-200.623 243.647)",
    fill: "#fff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M278.6-198.093h-3.995v-3.716H278.6Z",
    transform: "translate(-243.387 243.647)",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M278.6-163.166h-3.995v-1.1H278.6Z",
    transform: "translate(-243.387 210.376)",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M319.384-187.241h3.995v3.716h-3.995Z",
    transform: "translate(-283.073 230.736)",
    fill: "#fff"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M319.384-201.809h3.995v1.1h-3.995Z",
    transform: "translate(-283.073 243.647)",
    fill: "#fff"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(43.791 36.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M-184.724-10.092h-23.7v-.8a.492.492,0,0,1,.492-.492h22.712a.492.492,0,0,1,.492.492Z",
    transform: "translate(208.419 11.387)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(43.791 37.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M-182.864-1.859V7.954a.409.409,0,0,1-.409.409h-22.4a.409.409,0,0,1-.409-.409V-1.859Zm.239-.239h-23.7V7.954a.647.647,0,0,0,.647.647h22.4a.647.647,0,0,0,.647-.647Z",
    transform: "translate(206.321 2.098)",
    fill: "#140577"
  })))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M395.405-223.141h-2.981v-8.6h2.981Z",
    transform: "translate(-347.809 270.177)",
    fill: "#d6d3ea"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M472.184-223.141H457.779v-8.6h14.405Z",
    transform: "translate(-405.734 270.177)",
    fill: "#d6d3ea"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M477.46-226.853H464.528v-.877H477.46Z",
    transform: "translate(-411.715 266.621)",
    fill: "#fff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M477.46-214.935H464.528v-.439H477.46Z",
    transform: "translate(-411.715 255.67)",
    fill: "#fff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M427.14-214.348h-2.982v-1.026h2.982Z",
    transform: "translate(-375.936 255.67)",
    fill: "#d6d3ea"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M467.311-202.77h-2.782v-5.26h2.782Z",
    transform: "translate(-411.716 249.161)",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M527.384-202.77H524.6v-5.26h2.782Z",
    transform: "translate(-464.96 249.161)",
    fill: "#fff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M497.365-203.581h-3.02v-5.5h3.02Zm-2.782-.239h2.543v-5.022h-2.543Z",
    transform: "translate(-438.142 250.092)",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M555.78-203.581h-3.02v-5.5h3.02ZM553-203.819h2.543v-5.022H553Z",
    transform: "translate(-489.916 250.092)",
    fill: "#fff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M427.14-197.981h-2.982v-1.026h2.982Z",
    transform: "translate(-375.936 241.164)",
    fill: "#d6d3ea"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M427.14-181.613h-2.982v-1.026h2.982Z",
    transform: "translate(-375.936 226.657)",
    fill: "#d6d3ea"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M427.14-165.246h-2.982v-1.026h2.982Z",
    transform: "translate(-375.936 212.151)",
    fill: "#d6d3ea"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(33.321 9.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M-86.99,0H-95.6a2.068,2.068,0,0,0-2.068,2.068,2.057,2.057,0,0,0,.237.96L-98.1,4.254a.368.368,0,0,0,.467.516l1.606-.681a2.069,2.069,0,0,0,.431.046h8.608a2.068,2.068,0,0,0,2.068-2.068A2.068,2.068,0,0,0-86.99,0",
    transform: "translate(98.148)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(35.523 10.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M-11.407-5.7a.732.732,0,0,1-.732.732A.732.732,0,0,1-12.87-5.7a.732.732,0,0,1,.732-.732.732.732,0,0,1,.732.732",
    transform: "translate(12.87 6.435)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(38.193 10.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M-11.407-5.7a.732.732,0,0,1-.732.732A.732.732,0,0,1-12.87-5.7a.732.732,0,0,1,.732-.732.732.732,0,0,1,.732.732",
    transform: "translate(12.87 6.435)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(40.863 10.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M-11.407-5.7a.732.732,0,0,1-.732.732A.732.732,0,0,1-12.87-5.7a.732.732,0,0,1,.732-.732.732.732,0,0,1,.732.732",
    transform: "translate(12.87 6.435)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    transform: "translate(43.533 10.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M-11.407-5.7a.732.732,0,0,1-.732.732A.732.732,0,0,1-12.87-5.7a.732.732,0,0,1,.732-.732.732.732,0,0,1,.732.732",
    transform: "translate(12.87 6.435)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(65.291 30.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M-86.99,0H-95.6a2.068,2.068,0,0,0-2.068,2.068h0a2.056,2.056,0,0,0,.237.96L-98.1,4.254a.368.368,0,0,0,.467.516l1.606-.681a2.07,2.07,0,0,0,.431.046h8.608a2.068,2.068,0,0,0,2.068-2.068h0A2.068,2.068,0,0,0-86.99,0",
    transform: "translate(98.148)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(67.492 31.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M-11.407-5.7a.732.732,0,0,1-.732.732A.732.732,0,0,1-12.87-5.7a.732.732,0,0,1,.732-.732.732.732,0,0,1,.732.732",
    transform: "translate(12.87 6.435)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    transform: "translate(70.162 31.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M-11.407-5.7a.732.732,0,0,1-.732.732A.732.732,0,0,1-12.87-5.7a.732.732,0,0,1,.732-.732.732.732,0,0,1,.732.732",
    transform: "translate(12.87 6.435)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345",
    transform: "translate(72.832 31.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M-11.407-5.7a.732.732,0,0,1-.732.732A.732.732,0,0,1-12.87-5.7a.732.732,0,0,1,.732-.732.732.732,0,0,1,.732.732",
    transform: "translate(12.87 6.435)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    transform: "translate(75.502 31.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M-11.407-5.7a.732.732,0,0,1-.732.732A.732.732,0,0,1-12.87-5.7a.732.732,0,0,1,.732-.732.732.732,0,0,1,.732.732",
    transform: "translate(12.87 6.435)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(9.619 46.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M-111.936-.383l-.347.293a9.538,9.538,0,0,1-3.987,2l-.5.116a5.292,5.292,0,0,0-4.228-2.1,5.3,5.3,0,0,0-5.3,5.3,5.3,5.3,0,0,0,5.3,5.3,5.3,5.3,0,0,0,5.3-5.3c0-.082,0-.164-.006-.245l.483-.336a9.536,9.536,0,0,0,3.6-4.81.2.2,0,0,0-.324-.22",
    transform: "translate(126.294 0.432)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348",
    transform: "translate(11.518 49.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M-29.531-1.873l.717,1.454a.431.431,0,0,0,.324.236l1.6.233a.431.431,0,0,1,.239.735l-1.161,1.131a.431.431,0,0,0-.124.381l.274,1.6a.431.431,0,0,1-.625.454L-29.717,3.6a.431.431,0,0,0-.4,0l-1.435.754a.431.431,0,0,1-.625-.454l.274-1.6a.431.431,0,0,0-.124-.381L-33.189.785A.431.431,0,0,1-32.95.05l1.6-.233a.431.431,0,0,0,.324-.236l.717-1.454a.431.431,0,0,1,.773,0",
    transform: "translate(33.319 2.113)",
    fill: "#fff"
  })))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M41.766-273.657H27.913v-3.577H41.766Z",
    transform: "translate(-24.74 310.497)",
    fill: "#9b2dff"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350",
    transform: "translate(3.911 33.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M-32.246,0l-.863,2.38h-.664L-34.307.9-34.86,2.38h-.663L-36.382,0h.65l.562,1.61L-34.586,0H-34l.566,1.61L-32.856,0Z",
    transform: "translate(36.382)",
    fill: "#fff"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351",
    transform: "translate(7.999 33.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M-32.246,0l-.863,2.38h-.664L-34.307.9-34.86,2.38h-.663L-36.382,0h.65l.562,1.61L-34.586,0H-34l.566,1.61L-32.856,0Z",
    transform: "translate(36.382)",
    fill: "#fff"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352",
    transform: "translate(12.087 33.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M-32.247,0l-.863,2.38h-.664L-34.308.9l-.553,1.478h-.664L-36.383,0h.65l.562,1.61L-34.587,0H-34l.566,1.61.58-1.61Z",
    transform: "translate(36.383)",
    fill: "#fff"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    transform: "translate(2.44 33.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M0,0H1.467M0,3.577H1.467M.734,0V3.577",
    fill: "none",
    stroke: "#38356d",
    strokeMiterlimit: 10,
    strokeWidth: 2.098
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(39.288 32.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M-18.922-5.071-20.135-5.4l-1.214-.325.325,1.214.325,1.214.665-.665,1.386,1.386.447-.447-1.386-1.386Z",
    transform: "translate(21.349 5.721)",
    fill: "#f2a51c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebdevdet);
export default __webpack_public_path__ + "static/media/webdevdet.1ac5b1b27b91abf18b8dd2f1c082ec4a.svg";
export { ForwardRef as ReactComponent };